module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray-a64b52c8f2975121108f3ba56a5ff322.png";